var SnhuUtilities = {
    //
    GetParameterByName: function (name) {
        name = String(name).replace(/[.*+?|()[\]{}\\]/g, '\\$&');
        var match = RegExp('[?&]' + name + '=([^&]*)', 'i').exec(window.location.search);
        return match && (decodeURIComponent(match[1].replace(/\+/g, ' ')));
    },

    GetCurrentDateTime: function () {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd };
        if (mm < 10) { mm = '0' + mm };

        var hours = today.getHours();
        var minutes = today.getMinutes();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        var seconds = today.getSeconds();
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        var milliseconds = today.getMilliseconds();
        if (milliseconds < 10) {
            milliseconds = '0' + seconds;
        }

        var today = mm + '/' + dd + '/' + yyyy + ' ' + hours + ':' + minutes + ':' + seconds + '.' + milliseconds;
        return today;
    },

    TextCounter: function (field, cnt, maxlimit) {         
        var cntfield = document.getElementById(cnt) 
        if (field.value.length > maxlimit) { // if too long...trim it!
            field.value = field.value.substring(0, maxlimit);
        }else{
        // otherwise, update 'characters left' counter        
        cntfield.value = maxlimit - field.value.length;
        }
    },

    SetCookie: function(cname, cvalue, exdays, path) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString() + "; path=" + path;
        document.cookie = cname + "=" + cvalue + "; " + expires;
    },

    GetCookie: function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length,c.length);
            }
        }
        return "";
    },

    ExpireCookie: function(cname) {
        SnhuUtilities.SetCookie(cname, '', -1, '/');
    }
};
